<template>
  <div>
    <PCNavbar selectIndex="2" pageType="production" :currentIndex="currentIndex" :section3ScrollTop="section3ScrollTop" />
    <!-- <MobileNavBar :currentActive="2" /> -->
    <Product @current-index-change="handleCurrentIndexChange" @section-3-scroll-top-change="handleSection3ScrollTopChange" />
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
// import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import Product from '@/components/product/index.vue'
export default {
  components: {
    PCNavbar,
    Product
  },
  data() {
    return {
      currentIndex: 0,
      section3ScrollTop: 0
    }
  },
  methods: {
    handleCurrentIndexChange(index) {
      this.currentIndex = index;
      if (index !== 1) {
        this.section3ScrollTop = 0;
      }
    },
    handleSection3ScrollTopChange(scrollTop) {
      this.section3ScrollTop = scrollTop;
    }
  }
}
</script>

<style>
</style>